import { ChevronRightThin } from "assets/svg";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.colorsNew.base.white};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.colorsNew.gray[300]};
  padding: ${({ theme }) => theme.padding.p10} ${({ theme }) => theme.padding.p16};
  cursor: pointer;
  transition: background-color 0.3s ease;
  height: 52px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.colorsNew.gray[50]};
  }
`;

export const InnerLeftContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const InnerRightContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const UserRolesContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.padding.p12};
`;

export const ArrowIcon = styled(ChevronRightThin)`
  margin-left: ${({ theme }) => theme.margin.m12};
`;
